import { z } from 'zod';

import {
  refineDeliveryDateTimeRanges,
  zodCallOffPayloadFieldsSchema,
  zodCallOffResponseSchema,
  zodCreateCallOffItemPayloadSchema,
} from '../validations';

// Request payload schema for creating a call-off
// Extend the fields schema first, then apply date and time range refinements
export const zodCreateCallOffPayloadSchema = refineDeliveryDateTimeRanges(
  zodCallOffPayloadFieldsSchema.extend({
    calloffNumber: z.string().max(100).nullish(),
    contractId: z.uuid(),
    items: z.array(zodCreateCallOffItemPayloadSchema).min(1),
  }),
);

// Response schema for created call-off (re-export from shared)
export { zodCallOffResponseSchema as zodCreateCallOffResponseSchema };
